<div class="profile-bar">
  <div class="profile-bar-content">
    <img alt="SportsEngine"
      width="56px"
      height="14px"
      [src]="seIcon">
    <se-fe-avatar
      seFeDataType="persona"
      [seFeDataIdentity]="selfPersona.first_name + ' ' + selfPersona.last_name"
      [seFeDataImgUrl]="avatarIcon"
      seFeDataSize="200">
    </se-fe-avatar>
  </div>
</div>
